import * as React from "react";

import { cn } from "@werkstatt/utils";

export interface NavPillProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  badge?: React.ReactNode;
  active?: boolean;
  collapsed?: boolean;
}

const NavPill = React.forwardRef<HTMLButtonElement, NavPillProps>(
  ({ icon: Icon, label, badge, active, collapsed, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        "flex w-full items-center rounded-pill text-sm font-medium transition-all duration-200",
        collapsed
          ? "flex-col justify-center gap-1 px-2 py-2"
          : "flex-row gap-2.5 px-3.5 py-2",
        active
          ? "bg-[image:var(--sphere-active-gradient)] text-white shadow-glow"
          : "text-muted-foreground hover:bg-[rgb(var(--sphere-border)_/_var(--sphere-hover-alpha))] hover:text-foreground",
        className,
      )}
      {...props}
    >
      <Icon
        className={cn("shrink-0", collapsed ? "h-6 w-6" : "h-[18px] w-[18px]")}
      />
      {!collapsed && (
        <>
          <span className="min-w-0 flex-1 truncate text-left">{label}</span>
          {badge}
        </>
      )}
    </button>
  ),
);
NavPill.displayName = "NavPill";

export { NavPill };
